import { Directive, OnDestroy } from '@angular/core';
import { SubscriptionLike } from 'rxjs';

/** Helper class that unsubscribes all subscriptions on component destroy */
export class SubscriptionsManager {
  protected subscriptions: SubscriptionLike[] = [];
  protected cleanFunctions: (() => void)[] = [];

  add(subscription: SubscriptionLike) {
    this.subscriptions.push(subscription);
  }

  addCleanFunction(cleanFunction: () => void) {
    this.cleanFunctions.push(cleanFunction);
  }

  unsubscribeAll() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });

    this.cleanFunctions.forEach((cleanFunction) => {
      if (cleanFunction) {
        cleanFunction();
      }
    });
  }
}

/**
 * Helper directive that unsubscribes all subscriptions on component destroy using the
 * SubscriptionsManager
 */
@Directive()
export class AutoUnsubscribe implements OnDestroy {
  protected readonly subscriptionsManager = new SubscriptionsManager();

  ngOnDestroy(): void {
    this.subscriptionsManager.unsubscribeAll();
  }
}
